<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Hủy kết luận chỉ đạo
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="200px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                v-model="form.note"
                type="textarea"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                show-word-limit
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Hủy KLCĐ
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import Vue from "vue";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseCommandsService from "../../../services/hcCaseCommandsService";

export default {
  name: "hc-command-huy-yeu-cau-dialog",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: { CustomDialog },

  data() {
    return {
      form: {
        note: null
      },
      rules: {
        note: null
      }
    };
  },

  created() {
    this.initValidationRules();
  },

  methods: {
    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      Vue.set(this.rules, "note", [defaultRequiredConstrains]);
    },

    convertToSubmitForm() {
      return { note: this.form.note };
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    save() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcCaseCommandsService
            .huyYeuCau(this.id, submitForm)
            .then(response => response.data);
        })
        .then(hcCaseCommands => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommand.huyYeuCauSuccess"
            }),
            type: "success"
          });
          this.$emit("success", { result: hcCaseCommands });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-huy-yeu-cau-dialog.vue